import React, {useEffect, useState} from 'react';
import CookieConsentView from './CookieConsentView';
import CookieSettingsPanelView from './CookieSettingsPanelView';
import {applyGoogleConsent, initializeGTM} from './cookieHelper';

export const COOKIE_CONSENT_KEY = 'cookieConsent';
export const COOKIE_PREFERENCES_KEY = 'cookiePreferences';

const defaultPreferences = {
    necessary: true,
    functional: false,
    analytics: false,
    marketing: false,
};

function CookieConsent() {
    const [showBanner, setShowBanner] = useState(false);
    const [showPanel, setShowPanel] = useState(false);
    const [preferences, setPreferences] = useState(defaultPreferences);

    useEffect(() => {
        const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
        if (!consent) {
            setShowBanner(true);
        }
    }, []);

    const handleAcceptAll = () => {
        const allAccepted = {necessary: true, functional: true, analytics: true, marketing: true};
        localStorage.setItem(COOKIE_CONSENT_KEY, 'all');
        localStorage.setItem(COOKIE_PREFERENCES_KEY, JSON.stringify(allAccepted));
        initializeGTM(allAccepted);
        applyGoogleConsent(allAccepted);
        setShowBanner(false);
        setShowPanel(false);
    };

    const handleAcceptNecessary = () => {
        const necessaryOnly = {necessary: true, functional: false, analytics: false, marketing: false};
        localStorage.setItem(COOKIE_CONSENT_KEY, 'necessary');
        localStorage.setItem(COOKIE_PREFERENCES_KEY, JSON.stringify(necessaryOnly));
        // analytics=false → GTM is NOT initialized, no tracking cookies will be set
        setShowBanner(false);
        setShowPanel(false);
    };

    const handleOpenSettings = () => {
        const saved = localStorage.getItem(COOKIE_PREFERENCES_KEY);
        if (saved) {
            try {
                setPreferences(JSON.parse(saved));
            } catch {
                setPreferences(defaultPreferences);
            }
        }
        setShowPanel(true);
        setShowBanner(false);
    };

    const handleClosePanel = () => {
        setShowPanel(false);
        const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
        if (!consent) {
            setShowBanner(true);
        }
    };

    const handleTogglePreference = (id) => {
        if (id === 'necessary') return;
        setPreferences(prev => ({...prev, [id]: !prev[id]}));
    };

    const handleSavePreferences = () => {
        localStorage.setItem(COOKIE_CONSENT_KEY, 'custom');
        localStorage.setItem(COOKIE_PREFERENCES_KEY, JSON.stringify(preferences));
        initializeGTM(preferences);    // only starts GTM if analytics/marketing toggled ON
        applyGoogleConsent(preferences);
        setShowBanner(false);
        setShowPanel(false);
    };

    if (!showBanner && !showPanel) return null;

    return (
        <>
            {showBanner && (
                <CookieConsentView
                    onAcceptAll={handleAcceptAll}
                    onAcceptNecessary={handleAcceptNecessary}
                    onMoreSettings={handleOpenSettings}
                />
            )}
            {showPanel && (
                <CookieSettingsPanelView
                    preferences={preferences}
                    onToggle={handleTogglePreference}
                    onSave={handleSavePreferences}
                    onAcceptAll={handleAcceptAll}
                    onClose={handleClosePanel}
                />
            )}
        </>
    );
}

export default CookieConsent;
